// src/components/Header.jsx
import React, { useState } from 'react';
import AppLogo from '../assets/Favicon.png';

const Header = ({ activeSection, scrollToSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const sections = ['home', 'treasuCRE', 'services', 'about'];

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <>
      {/* ————————————————————————————— Fixed top bar ————————————————————————————— */}
      <div
        className="
          fixed top-0 inset-x-0 h-16
          bg-transparent md:bg-lavender
          flex items-center justify-between
          px-4 z-50 relative
        "
      >
        {/* Logo (always left) */}
        <img
          src={AppLogo}
          alt="App Logo"
          className="h-12 w-12 object-contain"
        />

        {/* Mobile “Connect” (only on <md) */}
        <button
          onClick={() => (window.location.href = 'mailto:connect@realalfa.ca')}
          className="
            md:hidden
            absolute right-4
            bg-gradient-to-r from-blueGradient through-purpleGradient to-otherpurpleGradient
            text-lavender px-6 py-2 rounded-full shadow-lg
            hover:from-indigo-600 hover:to-purple-400 transition duration-300
          "
        >
          Connect
        </button>

        {/* Hamburger (mobile only) */}
        <button
          onClick={() => setIsMenuOpen(o => !o)}
          className="
            md:hidden
            absolute left-1/2 transform -translate-x-1/2
            bg-deepIndigo text-lavender
            p-2 rounded-full focus:outline-none
          "
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={
                isMenuOpen
                  ? 'M6 18L18 6M6 6l12 12'
                  : 'M4 6h16M4 12h16M4 18h16'
              }
            />
          </svg>
        </button>

        {/* Desktop nav (unchanged) */}
        <nav className="hidden md:flex items-center space-x-8 text-lg font-light font-Merriweather text-deepIndigo">
          {sections.map((section) => (
            <button
              key={section}
              onClick={() => scrollToSection(section)}
              className={`
                capitalize relative hover:text-customGrey
                ${activeSection === section
                  ? 'after:content-[""] after:absolute after:left-0 after:right-0 after:bottom-[-8px] after:h-[3px] after:bg-deepIndigo after:rounded-md'
                  : ''
                }
              `}
            >
              {section}
            </button>
          ))}
        </nav>

        {/* Desktop “Connect” (unchanged) */}
        <div className="hidden md:block">
          <button
            onClick={() => (window.location.href = 'mailto:connect@realalfa.ca')}
            className="
              bg-gradient-to-r from-blueGradient through-purpleGradient to-otherpurpleGradient
              text-lavender px-6 py-2 rounded-full shadow-lg
              hover:from-indigo-600 hover:to-purple-400 transition duration-300
            "
          >
            Connect
          </button>
        </div>
      </div>

      {/* ————————————————————————————— Mobile menu + backdrop ————————————————————————————— */}
      {isMenuOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={closeMenu}
          />
          <div className="fixed top-16 left-0 right-0 bg-lavender z-50 flex flex-col items-center space-y-4 py-4 md:hidden">
            {sections.map((section) => (
              <button
                key={section}
                onClick={() => {
                  scrollToSection(section);
                  closeMenu();
                }}
                className={`
                  capitalize relative text-deepIndigo hover:text-customGrey
                  ${activeSection === section
                    ? 'after:content-[""] after:absolute after:left-0 after:right-0 after:bottom-[-8px] after:h-[3px] after:bg-deepIndigo after:rounded-md'
                    : ''
                  }
                `}
              >
                {section}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Header;
